module.exports = __webpack_public_path__ + "static/WEDDING E&M-202-00adaae366b7e8753d5b9cf7a6415cdc.jpg";